// import store from '@/state/store';
// import {inject} from "vue"; // Adjust the path as necessary

export default function middleware({to, next}) {

    const loginRoutes = [
        'admin-login',
        'login',
        'signup',
        'forgot-password',
        'reset-password',
        'validate-email',
        'verify-email',
    ];

    // TODO: Get login data from cookies?! currently from localStorage
    // const loginData = $cookies.get('user', { parseJSON: true });
    const loginData = JSON.parse(localStorage.getItem('user'))

    // If login data exists
    if (loginData) {

        // Redirect to dashboard if accessing login routes
        if (loginRoutes.includes(to.name)) {
            return next({name: 'dashboard'});
        }
        return next();

    } else {
        // Allow access to admin-login route even if not logged in
        // if (to.name === 'admin-login') {
        //     return next();
        // }

        // If not logged in, redirect to login for other protected routes
        if (!loginRoutes.includes(to.name)) {
            return next({ name: 'login' });
        }
        return next();
    }
}
